export default "__VITE_ASSET__WkqUmnx2__"